import { useEffect } from "react";

// Окно программы открылось, а сервер не ответил (нет сети, выкатка, компьютер
// только что проснулся). Форма входа тут соврала бы — пользователь уже вошёл,
// а показывать в углу экрана «нет связи» без звонка незачем: программа сама
// отмечает это на значке в трее (сообщение auth: unreachable). Повторяем сами —
// когда сеть вернулась и раз в 10 секунд.
//
// `note` — обычное окно программы («Интервью»): оно открыто перед человеком, и
// пустой белый лист в нём выглядел бы поломкой — там говорим, чего ждём.
export function TrayOffline({ onRetry, note = false }: { onRetry: () => void; note?: boolean }) {
  useEffect(() => {
    const timer = window.setInterval(onRetry, 10_000);
    window.addEventListener("online", onRetry);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("online", onRetry);
    };
  }, [onRetry]);
  return note ? <div className="app-loading">Нет связи с сервером — пробуем ещё раз…</div> : null;
}
